export enum estadoSistemaSeg {
    EnServicio = 0,
    FueraDeServicio = 1,
    NoAplica = 2,
    Remoto = 3,
    Local = 4
}